<template>
  <li :class="`a-alert-primary ${alert.messageClass}`">
    <p class="a-alert-primary-message">{{ alert.messageText }}</p>
    <a
      class="a-alert-primary-close"
      href="cerrar"
      @click.prevent="$alerts.closeAlert(index)"
    >
      <i class="fas fa-times"></i>
    </a>
  </li>
</template>

<script>
export default {
  name: 'AtomAlertPrimary',

  props: {
    'alert': Object,
    'index': Number
  }
}
</script>
